import { formatDistanceToNow, isValid, parseISO } from 'date-fns';

export const formatDateToTimeAgo = (value: string | null | undefined): string => {
  if (!value) return '';
  const date = parseISO(value);
  if (!isValid(date)) return '';
  const fullDistance = formatDistanceToNow(date);

  return fullDistance
    .replace(/years?/, 'y')
    .replace(/months?/, 'mo')
    .replace(/weeks?/, 'w')
    .replace(/days?/, 'd')
    .replace(/hours?/, 'h')
    .replace(/minutes?/, 'm')
    .replace(/seconds?/, 's')
    .replace('about ', '')
    .replace('less than ', '')
    .replace('almost ', '')
    .replace('over ', '')
    .replace('a ', '1 ')
    .replace('an ', '1 ');
};
